import { alpha, Stack } from '@mui/material';

export function SubdirectoryHeadLessArrowRightIcon() {
  return (
    <Stack
      sx={{
        width: '13px',
        height: '13px',
        borderWidth: '0 0 1px 1px',
        borderStyle: 'solid',
        borderColor: (theme) => alpha(theme.palette.action.active, 0.56),
      }}
    ></Stack>
  );
}
